export { default } from './buildEndpointsGuide';
